/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutModule_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDetails_viewer" | "PdpSharedDescriptionAdditionalOptions_viewer">;
    readonly " $refType": "PdpRespAboutModule_viewer";
};
export type PdpRespAboutModule_viewer$data = PdpRespAboutModule_viewer;
export type PdpRespAboutModule_viewer$key = {
    readonly " $data"?: PdpRespAboutModule_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespAboutModule_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespAboutModule_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptions_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'ba356d73d1f0e94eb0de64d9929c4692';
export default node;
